import React, { FC } from 'react';
import { CommonApp } from '../../../common/components/common-app/CommonApp';
import { DecisionUpload } from './DecisionUpload';
import { DecisionUploadContext } from './DecisionUploadContext';
import { JurisdictionsType } from '../decisionUpload.types';

type Props = {
  jurisdictionsKeys: string[];
  plansAllowed: string[];
  jurisdictions: JurisdictionsType | null;
};

export const DecisionUploadApp: FC<Props> = ({
  jurisdictionsKeys,
  plansAllowed,
  jurisdictions,
}) => (
  <CommonApp>
    <DecisionUploadContext.Provider
      value={{ jurisdictionsKeys, plansAllowed, jurisdictions }}
    >
      <DecisionUpload />
    </DecisionUploadContext.Provider>
  </CommonApp>
);
